import Utils from "../utils/node.utils"

export function getSubCategories(edges, parent, options) {
  let mainCategories = {}
  let subCategories = {}

  if (!options) {
    options = {}
  }

  for (let i in edges) {
    const category = edges[i].node.item

    if (options.filter && category.key !== options.filter) {
      continue
    }

    const key = Utils.GetContentKeyValueWithDefault(
      category.content,
      "name",
      options.locale
    )

    if (category.page_children && category.page_children.length !== 0) {
      mainCategories[key] = !parent

      for (let i in category.page_children) {
        const subCategory = category.page_children[i]
        const key = Utils.GetContentKeyValueWithDefault(
          subCategory.content,
          "name",
          options.locale
        )
        subCategories[key] = false
      }
    }
  }

  return {
    subCategories: subCategories,
    mainCategories: mainCategories,
  }
}
